import { GET_WITHDRAWAL_INFO_URL, getWithdrawalInfo } from 'src/clients';
import useSWR from 'swr';

const fallbackWithdrawalInfo = {
  maxWithdrawAmount: 0,
  withdrawAdminFee: 0,
  withdrawTax: 0,
};

export const useWithdrawalInfo = () => {
  const { data: withdrawalInfo, ...swr } = useSWR(
    GET_WITHDRAWAL_INFO_URL,
    () =>
      getWithdrawalInfo().then(res => res.data.data ?? fallbackWithdrawalInfo),
    { fallbackData: fallbackWithdrawalInfo },
  );
  const {
    maxWithdrawAmount: maxWithdrawalAmount,
    withdrawAdminFee,
    withdrawTax,
  } = withdrawalInfo;
  const data = { maxWithdrawalAmount, withdrawAdminFee, withdrawTax };
  return { data, ...swr };
};
